// Bagi navItems (navConfig.js) jadi 4 tab utama bottom bar + sisanya buat sheet More.
export const PRIMARY_TAB_KEYS = ['home', 'dashboard', 'report', 'voyage'];
const TAB_COUNT = 4;

export function mobileTabs(navItems, primaryNames = PRIMARY_TAB_KEYS) {
  const items = Array.isArray(navItems) ? navItems : [];
  const used = new Set();
  const tabs = [];

  primaryNames.forEach((key) => {
    const item = items.find((candidate) => candidate.key === key && !used.has(candidate));
    if (item) {
      tabs.push(item);
      used.add(item);
    }
  });

  items.some((item) => {
    if (tabs.length >= TAB_COUNT) return true;
    if (!used.has(item)) {
      tabs.push(item);
      used.add(item);
    }
    return false;
  });

  const more = items.filter((item) => !used.has(item));
  return { tabs, more };
}
